module.exports = __webpack_public_path__ + "static/media/Melisandre 1.f0ae4a34.jpg";